import { ReactNode } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import Logo from '@/components/ui/logo'
import Footer from '@/components/layout/Footer'

interface AuthLayoutProps {
  children: ReactNode
  title: string
  description: string
}

const AuthLayout = ({ children, title, description }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="flex-1 flex items-center justify-center p-2 sm:p-4">
        <div className="w-full max-w-sm sm:max-w-md">
          <div className="flex items-center justify-center mb-4 sm:mb-6 md:mb-8">
            <div className="flex items-center space-x-2">
              <div className="bg-gradient-to-r from-primary to-primary-glow p-2 sm:p-2.5 md:p-3 rounded-full shadow-glow">
                <Logo className="h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8" />
              </div>
              <div className="text-left">
                <h1 className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-primary to-primary-glow bg-clip-text text-transparent">
                  Herzensempfehlung
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground">Digitale Treuekarten</p>
              </div>
            </div>
          </div>
          
          <Card className="shadow-soft border-0 bg-card/80 backdrop-blur-sm">
            <CardHeader className="text-center px-3 sm:px-4 md:px-6 py-4 sm:py-5 md:py-6">
              <CardTitle className="text-lg sm:text-xl md:text-2xl">{title}</CardTitle>
              <CardDescription className="text-sm">{description}</CardDescription>
            </CardHeader>
            <CardContent className="px-3 sm:px-4 md:px-6 pb-4 sm:pb-5 md:pb-6">
              {children}
            </CardContent>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default AuthLayout